<template>
  <div>
    <v-card
      :style="'padding: 20px; margin: 10;width: 100%;'"
      class="primary white--text">
      <v-layout
        wrap
        flex
        justify-center>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Usuários Ativos</p>
          <h3>{{ dataADM.usersCount }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Usuários 24hrs.</p>
          <h3>{{ dataADM.usersLast24 }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Empresas Ativas</p>
          <h3>{{ dataADM.empresaCount }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Alimentos Cadastrados</p>
          <h3>{{ dataADM.alimentosCount }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Dietas Ativas</p>
          <h3>{{ dataADM.dietasAtivasCount }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Dietas</p>
          <h3>{{ dataADM.dietasCount }}</h3>
        </v-flex>
        <v-flex style="text-align: center;  width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Dietas 24hrs.</p>
          <h3>{{ dataADM.dietasLast24 }}</h3>
        </v-flex>
        <v-flex style="text-align: center;  width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Dietas Bezerro</p>
          <h3>{{ dataADM.dietasBezerro }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Dietas Vaca</p>
          <h3>{{ dataADM.dietasVaca }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Dietas C&T</p>
          <h3>{{ dataADM.dietasCeT }}</h3>
        </v-flex>
      </v-layout>

    </v-card>
    <v-card
      class="success white--text"
      style="padding: 10px;">
      <v-layout>
        <v-flex style="text-align: center; padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Como encontrou o BR-Corte</p>
          <b
            v-for="canais in dataADM.userComoEncontrouCount"
            style="font-size: 20px;"><template v-if="canais.como_encontrou_brcorte !== null">{{ canais.como_encontrou_brcorte }} : {{ canais.qtd }} | </template></b>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card style="width: 100%; height: 1000px;">
      <div xs12>
        <h3>Dietas nos últimos 15 dias</h3>
        <chartist
          :data="dataChart"
          style="height: 350px; color: #fff; background: #fff"
          color="info"
          type="Line"
        />
      </div>

      <div xs12>
        <h3>Usuários nos últimos 15 dias</h3>
        <chartist
          :data="dataUserChart"
          style="height: 350px; color: #fff; background: #fff"
          color="info"
          type="Line"
        />
      </div>

    </v-card>
    <v-card
      :style="'padding: 20px; margin: 10;width: 100%;'"
      class="indigo white--text">
      <v-layout
        wrap
        flex
        justify-center>

        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Idade Média</p>
          <h3>{{ parseInt(dataADM.userIdadeMedia) }}</h3>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Sexo</p>

          <b
            v-for="sexo in dataADM.userSexoCount"
            :key="sexo.sexo"
            style="font-size: 20px;"><template v-if="sexo.sexo !== null">{{ sexo.sexo === null ? 'N.A.' : sexo.sexo }}: {{ sexo.qtd }} <br></template></b>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>Perfil</p>

          <b
            v-for="perfil in dataADM.userPerfilCount"
            :key="perfil.perfil"
            style="font-size: 20px;"><template v-if="perfil.perfil !== null">{{ perfil.perfil === null ? 'N.A.' : perfil.perfil }}: {{ perfil.qtd }} <br></template></b>
        </v-flex>
        <v-flex style="text-align: center; width: 200px;  padding-bottom: 10px; border-bottom: 1px #fff solid;">
          <p>GMD Média</p>

          <b style="font-size: 20px;">Bezerro: {{ parseFloat(dataADM.dietasBezerroGMD).toFixed(2) }}<br></b>
          <b style="font-size: 20px;">Vaca: {{ parseFloat(dataADM.dietasVacaGMD).toFixed(2) }}<br></b>
          <b style="font-size: 20px;">C&T: {{ parseFloat(dataADM.dietasCeTGMD).toFixed(2) }}<br></b>
        </v-flex>

      </v-layout>

    </v-card>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import ChartCard from '../../../components/material/ChartCard.vue'

export default {
  components: {
    ChartCard
  },
  data () {
    return {
      tabsEnum: ['usuarios', 'empresas', 'alimentos'],
      tab: null,
      logo: 'img/brcorte-logo.png',
      users: [],
      empresas: [],
      searchUsers: null,
      searchEmpresas: null,
      searchAlimentos: null,
      gerenciaPremium: false,
      alimentos: null,
      alimento: null,
      dialogPremium: false,
      dialogConsultor: false,
      dialogNutrientes: false,
      vincular: false,
      dataFim: null,
      userPivot: null,
      premium: false,
      tempo_premium: false,
      loading: false,
      limit: 7,
      pagina: 1,
      paginaTotal: 1,
      filtrarVinculados: false,
      filtrarConsultoria: false,
      filtrarPremium: false,
      filtrarPremiumVencido: false,
      filtrarAdmin: false,
      filtrarInativos: false,
      gerenciaConsultor: false,
      consultor: false,
      tempo_consultor: false,
      maxClientes: 10,
      countResultados: 0,
      dataADM: {},
      modoSuperUsuario: false
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas']),
    dailySalesChart () {
      return {
        data: {
          labels: Object.keys(this.dataADM.dietasPorDias),
          series: Object.values(this.dataADM.dietasPorDias)
        },
        options: {

          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      }
    },
    dataChart () {
      if (!this.dataADM || !this.dataADM.dietasPorDias || this.dataADM === null || this.dataADM.dietasPorDias === null) return { labels: [], series: [] }
      let dietasPorDias = {}
      Object.keys(this.dataADM.dietasPorDias).slice(0, 15).map(a => { dietasPorDias[a] = this.dataADM.dietasPorDias[a] })
      return { labels: Object.keys(dietasPorDias).reverse(), series: [Object.values(dietasPorDias).reverse()] }
    },
    dataUserChart () {
      if (!this.dataADM || !this.dataADM.userPorDias || this.dataADM === null || this.dataADM.userPorDias === null) return { labels: [], series: [] }
      let dietasPorDias = {}
      Object.keys(this.dataADM.userPorDias).slice(0, 15).map(a => { dietasPorDias[a] = this.dataADM.userPorDias[a] })
      return { labels: Object.keys(dietasPorDias).reverse(), series: [Object.values(dietasPorDias).reverse()] }
    },
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    filter () {
      return (item, search, textKey) => item[textKey].toLowerCase().search(search.toLowerCase()) > -1
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 200) + 'px; overflow: auto; min-height: 200px;'
    }
  },
  created () {
    this.axios.post('data/adm', {}).then(r => {
      this.dataADM = r.data.data
    })
  }
}
</script>
